import * as Yup from "yup";

export const StateSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});
